import { gql, QueryResult, useQuery } from "@apollo/client";

import {
  CollectionQuery,
  CollectionQueryResult,
} from "../../../generated/gql/graphql";

const GET_COLLECTIONS = gql`
  query GetCollections($query: CollectionQuery) {
    collections(query: $query) {
      items {
        id
        status
        sort
        name
        image
        userId
        sharedUserIds
        dateCreated
        dateUpdated
        createdBy
        externalServiceConnections
      }
    }
  }
`;

export default function useCollections(
  query?: CollectionQuery
): QueryResult<CollectionQueryResult> {
  return useQuery<CollectionQueryResult>(GET_COLLECTIONS, {
    variables: {
      query,
    },
  });
}
